import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Device } from 'icreate/common/models/device';
import { getValidationErrors, mapErrors, ValidationErrorMap } from 'icreate/common/validators';
import { deviceValidator } from 'icreate/common/validators/device/device-validator';

@Component({
    selector: 'app-device-dialog',
    templateUrl: './device-dialog.component.html',
    styleUrl: './device-dialog.component.css',
    standalone: false,
})
export class DeviceDialogComponent {
    isEditing: boolean = false;
    deviceName: string;
    repatedName: boolean = false;
    validationErrors: ValidationErrorMap = {};
    hasError: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            device: Device;
            currentDevices: Device[];
        },
        private dialogRef: MatDialogRef<DeviceDialogComponent>,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        if (this.data.device) {
            this.deviceName = this.data?.device.name;
            this.isEditing = true;
        }
    }

    closeDialog() {
        this.dialogRef.close();
    }

    onNameChange(event: { name: string; value: string }) {
        this.deviceName = event.value;
        this.updateValidationErrors();
    }

    save() {
        if (!this.isEditing) this.dialogRef.close(this.deviceName);
        else {
            const updatedDevice: Device = structuredClone(this.data.device);
            updatedDevice.name = this.deviceName;
            this.dialogRef.close(updatedDevice);
        }
    }

    isSaveDisabled() {
        if (!this.deviceName?.trim() || this.hasError) return true;

        if (this.data.device) {
            return this.deviceName === this.data.device.name;
        }

        return false;
    }

    updateValidationErrors(): void {
        const validationData = {
            name: this.deviceName?.trim(),
        };
        this.repatedName = false;

        if (this.deviceName?.trim()) {
            const isDuplicate = this.data.currentDevices.some(
                device => device.name === this.deviceName?.trim() && device.id !== this.data.device?.id
            );
            this.repatedName = isDuplicate;
        }

        const errors = getValidationErrors(deviceValidator(), validationData);
        const mappedErrors: { [key: string]: { message: string } } = mapErrors(errors) || {};

        if (this.repatedName) {
            mappedErrors['name'] = {
                message: this.translate.instant('device.dialog.name.repeated.error'),
            };
        }

        this.validationErrors = Object.keys(mappedErrors).length > 0 ? mappedErrors : null;

        this.hasError = Object.keys(mappedErrors).length > 0;
    }
}
